import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';

export interface SelectItemDialogData<T> {
    title: string;
    items: T[];
    bindLabel: string;
    bindValue?: string;
    placeholder?: string;
    searchFn?: (term: string, item: T) => boolean;
}

@Component({
    selector: 'app-select-item-dialog',
    templateUrl: './select-item-dialog.component.html',
    styleUrls: ['./select-item-dialog.component.scss'],
    standalone: false,
})
export class SelectItemDialogComponent<T = any> {
    @ViewChild('itemSelect') itemSelect: NgSelectComponent;

    constructor(
        private dialogRef: MatDialogRef<SelectItemDialogComponent<T>>,
        @Inject(MAT_DIALOG_DATA) public data: SelectItemDialogData<T>
    ) {
        // Open only after the dialog's enter animation finishes, otherwise ng-select
        // measures the (still animating) select box and mis-sizes the appended panel.
        this.dialogRef.afterOpened().subscribe(() => this.itemSelect?.open());
    }

    select(item: T): void {
        this.dialogRef.close(item);
    }

    close(): void {
        this.dialogRef.close();
    }
}
